/* eslint-disable prettier/prettier */
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Store, Select } from '@ngxs/store';
import { ToastService } from '../../../../services/toast.service';
import { DineEngineError } from '../../../../interfaces/dineengine-error.interface';
import { TextField } from '../../../../vendors/directus/interfaces/text-field.interface';
import { firstValueFrom, Observable } from 'rxjs';
import { LoyaltySection } from '../../../../vendors/directus/interfaces/main-settings.interface';
import { GlobalStateModel } from 'src/store/state.model';
import { RedeemRewardCouponCode, SetRewards } from '../../../../store/actions/user.actions';
import { User } from '../../../../interfaces/user.interface';
import { Order } from '../../../../interfaces/order.interface';

import { ContentService } from '../../../../services/vendor-config-service/content-provider.service';

@Component({
  selector: 'app-redeem-promo-section',
  templateUrl: './redeem-promo-section.component.html',
  styleUrls: ['./redeem-promo-section.component.scss'],
})
export class RedeemPromoSectionComponent implements OnInit {
  @Select((state: GlobalStateModel) => state.app.mainSettings?.enable_promo_codes) enablePromo$: Observable<boolean>;
  @Select((state: GlobalStateModel) => state.app.textField) textFields$: Observable<TextField>;
  @Select((state: GlobalStateModel) => state.user.user) user$: Observable<User>;
  @Select((state: GlobalStateModel) => state.order.order) order$: Observable<Order>;

  @Input() section: LoyaltySection;

  promoCodeForm = new UntypedFormGroup({
    promoCode: new UntypedFormControl(),
  });

  redeemPromoSuccessText = 'Promo Code Redeemed Successfully';

  constructor(
    private store: Store,
    private toast: ToastService,
    private content: ContentService
  ) {}

  ngOnInit() {
    this.textFields$.subscribe(textFields => {
      if (textFields) {
        this.redeemPromoSuccessText = textFields.redeem_code_success_text || this.redeemPromoSuccessText;
      }
    });
  }

  async redeemPromoCode(): Promise<void> {
    const promoCode: string | null = this.promoCodeForm.get('promoCode')?.value?.trim();

    if (!promoCode) {
      this.toast.showDismissableIonicToast('Please enter a promo code', 'de-ionic-warning-toast', 8000);
      return;
    }

    try {
      // Dispatch the real state action and await completion
      await firstValueFrom(this.store.dispatch(new RedeemRewardCouponCode(promoCode)));

      // Refresh rewards after successful promo code redemption
      const user = await firstValueFrom(this.user$);
      const order = await firstValueFrom(this.order$);
      
      if (user) {
        if (order?.location?.locationID) {
          this.store.dispatch(new SetRewards(user.userID, order.location.locationID));
        } else {
          // Get static location and refresh rewards
          const cService = await firstValueFrom(this.content.getService());
          const cLocations = await firstValueFrom(cService.getLocations());
          const staticLoc = cLocations.find(l => l.is_static_menu);
          if (staticLoc) {
            this.store.dispatch(new SetRewards(user.userID, staticLoc.menu_id));
          }
        }
      }

      // Success handling
      this.toast.showDismissableIonicToast(this.redeemPromoSuccessText, 'de-ionic-success-toast', 8000);
      this.promoCodeForm.reset();
    } catch (error) {
      // Error handling
      if (error instanceof DineEngineError) {
        this.toast.showDismissableIonicToast(error.message, 'de-ionic-error-toast', 8000);
      } else {
        this.toast.showDismissableIonicToast('Invalid promo code', 'de-ionic-error-toast', 8000);
      }
    }
  }
}
